module.exports = "<div class=\"advancedreg-emailus\"></div>\n    <div class=\"row\">\n        <div class=\"col-xs-12 text-center\">\n            <h3>We weren't able to verify your information.</h3>\n            <p class=\"subtitle\">\n                Please send a photo of your driver's license to <a href=\"mailto:ContractorESignCountersign@heroprogram.com\">ContractorESignCountersign@heroprogram.com</a> so we can verify your information.\n            </p>\n        </div>\n    </div>\n</div>\n\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/notificationCenter/modal/templates/advancedRegistration/emailUs/emailUs.html
// module id = 725
// module chunks = 1